import loafer2a from "./loaf2a.jpg";
import loafer2b from "./loaf2b.jpg";
import loafer4a from "./loaf4a.jpg";
import loafer4b from "./loaf4b.jpg";
import loafer6a from "./loaf6a.jpg";
import loafer6b from "./loaf6b.jpg";
import loafer7a from "./loaf7a.jpg";
import loafer7b from "./loaf7b.jpg";
import loafer8a from "./loafer8a.jpg";
import loafer9a from "./loafer9a.jpg";
import loafer10a from "./loafer10a.jpg";

import boot1ab from "./boot1ab.jpg";
import boot1b from "./boo1b.jpg";
import boot2a from "./boot2a.jpg";
import boot2b from "./boot2b.jpg";
import boot3b from "./boot3b.jpg";
import boot3a from "./boot3a.jpg";

import corp1a from "./corp1a.jpg";
import corp1b from "./corp1b.jpg";
import corp2a from "./corp2a.jpg";
import corp2b from "./corp2b.jpg";
// import corp3a from "./corp3a.jpg";
// import corp3b from "./corp3b.jpg";
import corp4a from "./corp4a.jpg";
import corp4b from "./corp4b.jpg";
import corp5a from "./corp5a.jpg";
import corp5b from "./corp5b.jpg";
import corp6a from "./corp6a.jpg";

import mens1a from "./mens1a.jpg";
import mens1b from "./mens1b.jpg";
import mens2a from "./mens2a.jpg";
import mens2b from "./mens2b.jpg";
import mens3a from "./mens3a.jpg";
import mens3b from "./mens3b.jpg";
import mens4a from "./mens4a.jpg";
import mens4b from "./mens4a.jpg";
import mens5a from "./mens5b.jpg";
import mens5b from "./mens5b.jpg";
import mens6a from "./mens6a.jpg";
import mens6b from "./mens6b.jpg";
import mens7a from "./mens7a.jpg";
import mens7b from "./mens7b.jpg";
import mens8a from "./mens8a.jpg";
import mens8b from "./mens8b.jpg";

import w1a from "./w1a.jpg";
import w1b from "./1b.jpg";
import w2a from "./w2a.jpg";
import w2b from "./w2b.jpg";
import w3a from "./w3a.jpg";
import w3b from "./w3b.jpg";
import w4a from "./w4a.jpg";
import w4b from "./w4a.jpg";
import w5a from "./w5a.jpg";
import w5b from "./w5b.jpg";
import w6a from "./w6a.jpg";
import w6b from "./w6b.jpg";
import w7a from "./w7a.jpg";
import w7b from "./w7b.jpg";
import w8a from "./w8a.jpg";

import birk1a from "./birk1a.jpg";
import birk2a from "./birk2a.jpg";
import birk3a from "./birk3a.jpg";
import birk4a from "./birk4aa.jpg";
import birk4ab from "./birk4b.jpg";

export const productList = [
  {
    img: corp6a,
    name: "Classic Brown Leather Brogues",
    price: "$120",
    id: 101,
    sizes: [40, 41, 43, 44, 45],
    description: "Brogues for a timeless corporate look",
    searchEng: "brogues, leather, brown, corporate Men's Men male",
    otherImgs: [corp6a],
    ratings: 4.7,
  },

  {
    img: loafer2a,
    name: "Men's Leather slip-on loafers",
    price: "$980",
    id: 103,
    sizes: [40, 41, 43, 44, 45],
    description:
      "Authentic black leather loafers with animal print top, and a gold chain to match",
    searchEng: "loafers leather skin black Men's Men male",
    otherImgs: [loafer2b],
    ratings: 4.4,
  },
  {
    img: corp1a,
    name: "Classic suede double monkstraps",
    price: "$120",
    id: 102,
    sizes: [40, 41, 43, 44, 45],
    description: " Double buckled monkstrap brown suede shoes",
    searchEng: "brogues,brown, leather Corporate buckle make",
    otherImgs: [corp1b],
    ratings: 4.7,
  },
  {
    img: loafer4a,
    name: "Navy Blue white sole Loafers",
    price: "$610.50",
    id: 105,
    sizes: [40, 41, 43, 44, 45],
    description:
      "Stylish causal loafers suitable for pairing with native/casual outfits",
    searchEng:
      "loafers, leather, white sole skin Men's Men Unisex women male female",
    otherImgs: [loafer4b],
    ratings: 4.4,
  },
  {
    img: loafer10a,
    name: "Brown suede casual Loafers",
    price: "$720",
    id: 115,
    sizes: [40, 41, 43, 44, 45],
    description: "Suede loafers ",
    searchEng: "loafers, suede brown skin Men's Men",
    otherImgs: [loafer10a],
    ratings: 4.4,
  },
  {
    img: loafer6a,
    name: "Men's leather black loafers",
    price: "$370",
    id: 104,
    sizes: [40, 41, 43, 44, 45],
    description: "Classy tiny gold chain top loafers",
    searchEng: "loafers, leather skin Men's Men",
    otherImgs: [loafer6b],
    ratings: 4.4,
  },
  {
    img: loafer8a,
    name: "Smooth leather bold chain loafers ",
    price: "$1020",
    id: 107,
    sizes: [40, 41, 43, 44, 45],
    description: " black with bold gold chain top loafers",
    searchEng: "loafers, leather skin Men's Men",
    otherImgs: [loafer8a],
    ratings: 4.4,
  },

  {
    img: loafer7a,
    name: "Louis Vuitton custom top loafers",
    price: "$360",
    id: 108,
    sizes: [40, 41, 43, 44, 45],
    description: "Designer Louis Vuitton custom loafers ",
    searchEng: "loafers, suede Men's Men male",
    otherImgs: [loafer7b],
    ratings: 4.4,
  },
  {
    img: corp2a,
    name: "Leather lace up shoes",
    price: "$120",
    id: 265,
    sizes: [40, 41, 43, 44, 45],
    description: "Classic office or corporate shoes for a timeless look",
    searchEng: "brogues, leather Corporate black office Men's Men male",
    otherImgs: [corp2b],
    ratings: 4.7,
  },
  {
    img: loafer9a,
    name: "Tasseled suede loafers",
    price: "$310.50",
    id: 109,
    sizes: [40, 41, 43, 44, 45],
    description: "Fashionable brown tassel loafers ",
    searchEng: "loafers, leather skin Men's Men male",
    otherImgs: [loafer9a],
    ratings: 2.4,
  },
  {
    img: boot1ab,
    name: "Brown suede Chelsea Boots",
    price: "$870",
    id: 111,
    sizes: [40, 41, 43, 44, 45],
    description: "Trendy suede Chelsea boots for a fashionable look.",
    searchEng:
      "boots, suede ankle boots Chelsea Men's Men male Unisex women female",
    otherImgs: [boot1b],
    ratings: 4.6,
  },
  {
    img: corp4a,
    name: "Corporate Leather Oxfords",
    price: "$120",
    id: 439,
    sizes: [40, 41, 43, 44, 45],
    description: "Smooth Corporate Leather Oxfords ",
    searchEng: "oxford, leather  Men's Men male Unisex women female",
    otherImgs: [corp4b],
    ratings: 4.7,
  },
  {
    img: boot2a,
    name: "Black suede Chelsea Boots",
    price: "$870",
    id: 112,
    sizes: [40, 41, 43, 44, 45],
    description:
      "Trendy ankle-length suede Chelsea boots for a fashionable look.",
    searchEng:
      "boots, suede ankle boots Chelsea Men's Men male Unisex women female",
    otherImgs: [boot2b],
    ratings: 4.6,
  },
  {
    img: boot3b,
    name: "Blue/Black buckled suede Boots",
    price: "$920",
    id: 113,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy boots perfect for various occasions",
    searchEng:
      "boots, suede ankle boots Chelsea Men's Men male Unisex women female",
    otherImgs: [boot3a],
    ratings: 4.3,
  },
  {
    img: w1a,
    name: "White Casual Women's Slides",
    price: "$900",
    id: 114,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy slides perfect for summer outings",
    searchEng:
      "women's slides, white, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w1b],
    ratings: 4.3,
  },

  {
    img: w2a,
    name: "White Women's Slides",
    price: "$920",
    id: 23,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy women sandals perfect for summer outings",
    searchEng:
      "women's slides, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w2b],
    ratings: 4.5,
  },
  {
    img: w3a,
    name: "Classy Brown skin Women's Slides",
    price: "$950",
    id: 116,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy women slides for ladies",
    searchEng:
      "women's slides, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w3b],
    ratings: 4.6,
  },
  {
    img: w4a,
    name: "Strappy white Women's Slides",
    price: "$890",
    id: 117,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy women slides",
    searchEng:
      "women's slides, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w4b],
    ratings: 4.4,
  },
  {
    img: w5a,
    name: "Animal print Women's slip-ons",
    price: "$920",
    id: 118,
    sizes: [40, 41, 43, 44, 45],
    description:
      "Casual and classy furry double strap women sandals perfect for summer outings",
    searchEng:
      "women's slides, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w5b],
    ratings: 4.5,
  },
  {
    img: w6a,
    name: "Vinyl Leather strap slip-ons",
    price: "$940",
    id: 119,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and furry double strap cross women pam slides",
    searchEng:
      "women's slides, print, slip-ons, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w6b],
    ratings: 4.7,
  },
  {
    img: w7a,
    name: "Strappy Women Sandals",
    price: "$900",
    id: 120,
    sizes: [40, 41, 43, 44, 45],
    description:
      "Casual and classy Strappy Women Sandals perfect for summer outings",
    searchEng:
      "women's slides, slides, strappy, straps, gladiator, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w7b],
    ratings: 4.3,
  },

  {
    img: w8a,
    name: "Casual Women's Slides",
    price: "$920",
    id: 121,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy women sandals perfect for summer outings",
    searchEng:
      "women's slides, slides, casual, leather, female, female+slides, woman+slides",
    otherImgs: [w8a],
    ratings: 4.4,
  },
  {
    img: birk4a,
    name: "Double Strap Birkenstocks",
    price: "$120",
    id: 122,
    sizes: [40, 41, 43, 44, 45],
    description: "Classic Birkenstocks for a timeless look",
    searchEng:
      "birkenstocks, men's slides, slides, casual, , male, male+slides, men+slides female, female+slides, woman+slides",
    otherImgs: [birk4ab],
    ratings: 4.7,
  },
  {
    img: birk1a,
    name: "Herme`s Birkenstocks",
    price: "$120",
    id: 123,
    sizes: [40, 41, 43, 44, 45],
    description: "Classic Birkenstocks for a timeless look",
    searchEng:
      "birkenstocks, men's slides, slides, casual, , male, male+slides, men+slides female, female+slides, woman+slides",
    otherImgs: [birk1a],
    ratings: 4.7,
  },
  {
    img: birk2a,
    name: "Double Strap Buckle Birkenstocks",
    price: "$120",
    id: 124,
    sizes: [40, 41, 43, 44, 45],
    description: "Classic double strap buckle Birkenstocks for a timeless look",
    searchEng:
      "birkenstocks, men's slides, slides, casual, , male, male+slides, men+slides female, female+slides, woman+slides",
    otherImgs: [birk2a],
    ratings: 4.7,
  },
  {
    img: birk3a,
    name: "Birkenstocks Slides",
    price: "$1020",
    id: 125,
    sizes: [40, 41, 43, 44, 45],
    description: "Classic double strap buckle Birkenstocks for a timeless look",
    searchEng:
      "birkenstocks, men's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [birk3a],
    ratings: 4.7,
  },

  {
    img: mens1a,
    name: "Leather Men's Slides",
    price: "$910",
    id: 126,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, slides, casual,pam , male, male+slides, men+slides",
    otherImgs: [mens1b],
    ratings: 4.6,
  },
  {
    img: mens3a,
    name: "Suede Slides high sole",
    price: "$910",
    id: 127,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [mens3b],
    ratings: 4.6,
  },
  {
    img: mens2a,
    name: "Suede Slides high sole",
    price: "$910",
    id: 128,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [mens2b],
    ratings: 4.6,
  },
  {
    img: mens5a,
    name: " Black Sandals",
    price: "$910",
    id: 129,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides menslides sandals",
    otherImgs: [mens5b],
    ratings: 4.6,
  },
  {
    img: mens6a,
    name: "Casual Men slides",
    price: "$910",
    id: 130,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men slides for a casual look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [mens6b],
    ratings: 4.6,
  },
  {
    img: mens7a,
    name: "Black and brown slides",
    price: "$910",
    id: 131,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [mens7b],
    ratings: 4.6,
  },

  {
    img: mens4a,
    name: "Coffee brown Suede Slides",
    price: "$900",
    id: 132,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [mens4b],
    ratings: 4.5,
  },
  {
    img: mens8a,
    name: "White and black sandals",
    price: "$920",
    id: 133,
    sizes: [40, 41, 43, 44, 45],
    description: "Casual and classy men sandals for a fashionable look.",
    searchEng:
      "men's slides, women's slides, slides, casual, , male, male+slides, men+slides",
    otherImgs: [mens8b],
    ratings: 4.6,
  },
  {
    img: corp5a,
    name: "Black Leather Monkstraps",
    price: "$120",
    id: 134,
    sizes: [40, 41, 43, 44, 45],
    description: "Classic brogues for a timeless look",
    searchEng: "brogues, leather Corporate",
    otherImgs: [corp5b],
    ratings: 4.7,
  },
];
